import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const SamlCallback: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSamlResponse = async () => {
    try {
      setLoading(true);
      setError('');

      // Get SAML response from URL parameters or form data
      const urlParams = new URLSearchParams(window.location.search);
      const samlResponse = urlParams.get('SAMLResponse');
      const relayState = urlParams.get('RelayState');

      if (!samlResponse) {
        throw new Error('SAML response not found');
      }

      // In a real implementation, you would:
      // 1. Validate the SAML response signature
      // 2. Extract user attributes from the response
      // 3. Create a user session
      // 4. Redirect to the intended page

      // For demo purposes, we'll simulate successful authentication
      const mockUser = {
        userId: 'saml-user-123',
        email: 'test@sso-demo.com',
        fullName: 'SSO Test User'
      };

      // Create a mock token (in real implementation, this would be a proper JWT)
      const mockToken = btoa(JSON.stringify({
        userId: mockUser.userId,
        email: mockUser.email,
        fullName: mockUser.fullName,
        exp: Date.now() + 24 * 60 * 60 * 1000 // 24 hours
      }));

      // Store in localStorage
      localStorage.setItem('syberkey_token', mockToken);
      localStorage.setItem('syberkey_user', JSON.stringify(mockUser));

      // Redirect to dashboard or relay state
      const redirectUrl = relayState || '/dashboard';
      navigate(redirectUrl);

    } catch (err) {
      setError(err instanceof Error ? err.message : 'SAML authentication failed');
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSamlResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="loading-overlay">
            <div className="loading-content">
              <div className="loading-spinner"></div>
              <p>Processing SAML response...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-content">
            <h2>SAML Authentication Error</h2>
            <div className="error-message">
              {error}
            </div>
            <button 
              className="syberkey-login-btn"
              onClick={() => navigate('/')}
            >
              <div className="btn-content">
                <div className="btn-text">Return to Login</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SamlCallback;
